import React from "react";
import {
  Box,
  DialogContent,
  Typography,
  Stack,
  Avatar,
} from "@mui/material";
import DialogFooter from "../../components/dialog/dialogFooter";
import DialogHeader from "../../components/dialog/dialogHeader";
import BootstrapDialog from "../../components/dialog/index";
import moment from "moment";

const ViewSubmittedFormDialog = ({ open, onClose, formData }) => {
  if (!formData) return null;

  const worker = formData.workerId || formData.worker || null;

  return (
    <BootstrapDialog open={open} onClose={onClose} customWidth="600px">
      <DialogHeader
        title="Submitted By"
        handleClose={onClose}
      />
      <DialogContent dividers sx={{ p: 3 }}>
        {worker ? (
          <Stack spacing={2}>
            <Box
              sx={{
                p: 2,
                backgroundColor: "#F9FAFB",
                borderRadius: 2,
                border: "1px solid #E0E0E0",
              }}
            >
              <Stack direction="row" spacing={2} alignItems="center">
                <Avatar
                  sx={{
                    width: 50,
                    height: 50,
                    bgcolor: "primary.main",
                  }}
                >
                  {worker.firstName?.[0]?.toUpperCase() || 
                   worker.email?.[0]?.toUpperCase() || 
                   "W"}
                </Avatar>
                <Box flex={1}>
                  <Typography variant="body1" fontWeight={600} mb={0.5}>
                    {`${worker.firstName || ""} ${worker.lastName || ""}`.trim() || "N/A"}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" mb={1}>
                    {worker.email || "N/A"}
                  </Typography>
                  {formData.submittedAt && (
                    <Typography variant="caption" color="text.secondary">
                      Submitted: {moment(formData.submittedAt).format("DD-MMM-YYYY HH:mm")}
                    </Typography>
                  )}
                </Box>
              </Stack>
            </Box>
          </Stack>
        ) : (
          <Box
            sx={{
              p: 4,
              textAlign: "center",
            }}
          >
            <Typography variant="body1" color="text.secondary">
              No worker information available
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogFooter handleClose={onClose} />
    </BootstrapDialog>
  );
};

export default ViewSubmittedFormDialog;

